import { render, staticRenderFns } from "./devDomains.vue?vue&type=template&id=11424d98&scoped=true"
import script from "./devDomains.vue?vue&type=script&lang=js"
export * from "./devDomains.vue?vue&type=script&lang=js"
import style0 from "./devDomains.vue?vue&type=style&index=0&id=11424d98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11424d98",
  null
  
)

export default component.exports